import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { valueReconciliationProductTargetsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_stacktrace/product-planning-core/value-reconciliation/product-targets/')({
  validateSearch: zodValidator(valueReconciliationProductTargetsSearchSchema)
});